import SzczegolyZlecenia from '../zlecenia/SzczegolyZlecenia';
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import "./ZleceniaStyle/SzczegolyZleceniaTabela.css";
import logoImg from '../../LogoG3.png';

const API_URL = process.env.REACT_APP_API_URL;

function formatDate(dateString) {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}

function SzczegolyKlientaTabela({uzytkownik, klientId, klientData, adresData}) {
  const [zleceniaKlienta, setZleceniaKlienta] = useState([]);
  const [pokazZlecenieId, setPokazZlecenieId] = useState(null);
  const [existingFiles, setExistingFiles] = useState([]);

  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchZlecenia = async () => {
      try {
        const res = await axios.get(`${API_URL}/zlecenia/klient/${klientId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setZleceniaKlienta(res.data);
      } catch (err) {
        console.error('Błąd pobierania zleceń klienta:', err);
      }
    };
    fetchZlecenia();
  }, [klientId, token]);

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const res = await axios.get(
          `${API_URL}/pliki/klienci?id_klienta=${klientId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setExistingFiles(res.data);
      } catch (err) {
        console.error('Błąd pobierania listy plików:', err);
      }
    };
    fetchFiles();
  }, [klientId, token]);

  pdfMake.vfs = pdfFonts.default.vfs;

  const handleGenerujPDF = async (klientData, adresData, extraContent = []) => {
    if (!pokazZlecenieId) return;
    try {
      const res = await axios.get(`${API_URL}/zlecenia/${pokazZlecenieId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const opiek = await axios.get(`${API_URL}/pracownicy/${res.data.opiekun_zlecenia}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const opiekun = opiek.data;
      const data = res.data;

      function getAdresById(adresData, searchedId) {
        return adresData.find(a => a.id_adres === searchedId) || null;
      }
      const adres = getAdresById(adresData, data.id_adres);

      const formatDate = (str) =>
        str ? new Date(str).toLocaleString('pl-PL', { dateStyle: 'short', timeStyle: 'short' }) : '-';

      const docDefinition = {
        pageOrientation: 'landscape',
        pageMargins: [20, 40, 20, 70], // więcej miejsca na stopkę
        content: [
          {
            columns: [
              {
                width: 120,
                image: 'logo',
                fit: [120, 60],
                margin: [0, 0, 0, 10]
              },
              {
                width: '*',
                stack: [
                  { text: 'PROTOKÓŁ ZLECENIA', style: 'title', alignment: 'right' },
                  { text: `Numer: ${data.numer_zlecenia}`, style: 'header', alignment: 'right' }
                ]
              }
            ]
          },

          { text: 'Dane klienta', style: 'section' },
          {
            columns: [
              {
                width: '50%',
                stack: [
                  { text: `Grupa kliencka: ${klientData.grupa_kliencka}` },
                  { text: `${klientData.imie} ${klientData.nazwisko}` },
                  { text: `${klientData.nr_telefonu}` },
                  { text: `${klientData.adres_email || ' '}` }
                ]
              },
              {
                width: '50%',
                stack: [
                  { text: `${adres.kraj}` },
                  { text: `${adres.miasto} ${adres.kod_pocztowy}` },
                  { text: `${adres.ulica} ${adres.nr_domu} ${adres.nr_lokalu ? ' / ' + adres.nr_lokalu : ' '}` }
                ]
              }
            ]
          },

          { text: 'Podstawowe informacje', style: 'section' },
          {
            columns: [
              {
                width: '50%',
                stack: [
                  { text: `Rodzaj zlecenia: ${data.rodzaj_zlecenia}` },
                  { text: `Status: ${data.status}` },
                  { text: `Planowana data: ${formatDate(data.planowana_data_realizacji)}` }
                ]
              },
              {
                width: '50%',
                stack: [
                  { text: `Data realizacji od: ${formatDate(data.data_realizacji_od)}` },
                  { text: `Data realizacji do: ${formatDate(data.data_realizacji_do)}` },
                  { text: `Opiekun: ${opiekun.imie + ' ' + opiekun.nazwisko || '-'}` }
                ]
              }
            ]
          },

          { text: 'Opis', style: 'section' },
          { text: data.opis || '-', margin: [0, 0, 0, 10] },

          { text: 'Opis wykonanych prac', style: 'section' },
          { text: data.opis_prac || '-', margin: [0, 0, 0, 10] },

          { text: 'Pracownicy realizujący zlecenie', style: 'section' },
          {
            ul: data.pracownicy && data.pracownicy.length > 0
              ? data.pracownicy.map(p => `${p.imie} ${p.nazwisko}`)
              : ['Brak przypisanych pracowników']
          },

          // >>> Tabele kosztów/sprzedaży z komponentu:
          ...(Array.isArray(extraContent) ? extraContent : []),
        ],

        footer: (currentPage, pageCount) => ({
          columns: [
            {
              width: '*',
              text:
                'G3 Service Spółka Cywilna ul. Czechowa 26, 52-231 Wrocław, NIP: 894-304-45-35, ' +
                'tel. +48 660 750 350, e-mail: biuro@g3service.pl, www.g3service.pl',
              style: 'footer'
            },
            {
              width: 'auto',
              text: `Strona ${currentPage} z ${pageCount}`,
              alignment: 'right',
              style: 'footer'
            }
          ],
          margin: [20, 0] // ciaśniej po bokach dla stopki
        }),

        images: {
          logo: logoImg
        },

        styles: {
          compact: { fontSize: 8, lineHeight: 1.05 },
          title: {
            fontSize: 18,
            bold: true,
            alignment: 'center',
            color: '#003366',
            margin: [0, 0, 0, 15]
          },
          header: {
            fontSize: 14,
            bold: true,
            margin: [0, 10, 0, 10],
            color: '#003366'
          },
          section: {
            fontSize: 12,
            bold: true,
            margin: [0, 10, 0, 5],
            color: '#003366'
          },
          footer: {
            fontSize: 8,          // mniejsza czcionka w stopce
            color: 'gray',
            lineHeight: 1.05
          }
        },
        defaultStyle: {
          font: 'Roboto'
        }
      };

      pdfMake.createPdf(docDefinition).download(`zlecenie_${data.numer_zlecenia}.pdf`);
    } catch (err) {
      console.error('Błąd generowania PDF:', err);
      alert('Nie udało się wygenerować PDF.');
    }
  };

  return(
    <div className="zlecenia-klienta-section">
      <h3>Zlecenia klienta</h3>
      <table className="zlecenia-table">
        <thead>
          <tr>
            <th>Numer zlecenia</th>
            <th>Status</th>
            <th>Data</th>
            <th>Rodzaj</th>
          </tr>
        </thead>
        <tbody className='order-table-scroll'>
          {zleceniaKlienta.length > 0 ? (
            zleceniaKlienta.map((z) => (
              <tr key={z.id_zlecenia}>
                <td>
                  <button className="link-button" onClick={() => setPokazZlecenieId(z.id_zlecenia)}>
                    {z.numer_zlecenia}
                  </button>
                </td>
                <td>{z.status}</td>
                <td>{formatDate(z.planowana_data_realizacji)}</td>
                <td>{z.rodzaj_zlecenia}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="2">Brak zleceń</td>
            </tr>
          )}
        </tbody>
      </table>

      {pokazZlecenieId && (
        <SzczegolyZlecenia
          zlecenieId={pokazZlecenieId}
          onZamknij={() => setPokazZlecenieId(null)}
          onGenerujPDF={(extra) => handleGenerujPDF(klientData, adresData, extra)}
        />
      )}
    </div>
  );
}

export default SzczegolyKlientaTabela;
